// Config options:
// createGrade: ["upload", "google", "canvas"]
// login: ["native", "google", "canvas"]
// bulkImports: boolean
// feedbackCustomizations: ["hidePercentagesInGrades"]
// extraHelpCenterLink: {
//   title: "Help Center Title",
//   url: "Help Center URL",
// }

import { AuthMethod } from "@/components/auth/auth_methods";

const DEFAULT_CONFIG = {
  createGrade: ["upload", "google", "canvas"],
  maintenanceMessageKey: "maintenance-message-v2",
  login: [AuthMethod.Native, AuthMethod.Google],
  bulkImports: false,
  showOnboardingTour: true,
  feedbackCustomizations: [],
  hiddenTabsEssayView: ["closeToGrade"],
};

const getConfigForSubdomain = (subdomain) => {
  switch (subdomain) {
    case "tot":
    case "tot-beta":
    case "egcanvas":
      return {
        showOnboardingTour: false,
        createGrade: ["upload", "canvas", "canvas-manual"],
        maintenanceMessageKey: "tot-maintenance-message",
        login: [AuthMethod.Canvas],
        bulkImports: true,
        feedbackCustomizations: ["hidePercentagesInGrades"],
        hiddenTabsEssayView: [],
      };
    default:
      return DEFAULT_CONFIG;
  }
};

export default {
  namespaced: true,
  state: () => ({
    features: DEFAULT_CONFIG,
  }),
  mutations: {
    SET_FEATURES(state, features) {
      state.features = features;
    },
  },
  actions: {
    initConfig({ commit }, forceConfigName = "") {
      const envSubdomain = process.env.VUE_APP_FORCE_SUBDOMAIN;

      if (envSubdomain) {
        commit("SET_FEATURES", getConfigForSubdomain(envSubdomain));
        return;
      }

      const subdomains = window.location.host
        .replace("www.", "")
        .replace(".com", "")
        .split(".");

      if (forceConfigName || subdomains.length > 2) {
        commit(
          "SET_FEATURES",
          getConfigForSubdomain(forceConfigName || subdomains[0])
        );
      }
    },
  },
  getters: {
    features: (state) => state.features,
  },
};
